import {
    Quote,
    QuoteTenor,
    QuoteTypes,
} from '@liquitics/transaction';


export function getStaticQuotes(todayString: string) {
    const STATIC_QUOTES = [];
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.1D', QuoteTenor.T_1D, todayString, 1.1834, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.2D', QuoteTenor.T_2D, todayString, 1.1836, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.1W', QuoteTenor.T_1W, todayString, 1.1839, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.2W', QuoteTenor.T_2W, todayString, 1.1840, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.3W', QuoteTenor.T_3W, todayString, 1.1842, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.1M', QuoteTenor.T_1M, todayString, 1.1849, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.2M', QuoteTenor.T_2M, todayString, 1.1861, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.3M', QuoteTenor.T_3M, todayString, 1.1880, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.EUR.USD.6M', QuoteTenor.T_6M, todayString, 1.1895, QuoteTypes.FX));

    STATIC_QUOTES.push(new Quote('MM.EUR.1D', QuoteTenor.T_1D, todayString, 0.0075, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.2D', QuoteTenor.T_2D, todayString, 0.0080, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.1W', QuoteTenor.T_1W, todayString, 0.0300, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.2W', QuoteTenor.T_2W, todayString, 0.0500, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.3W', QuoteTenor.T_3W, todayString, 0.0630, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.1M', QuoteTenor.T_1M, todayString, 0.0850, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.2M', QuoteTenor.T_2M, todayString, 0.1450, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.3M', QuoteTenor.T_3M, todayString, 0.1850, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.EUR.6M', QuoteTenor.T_6M, todayString, 0.4450, QuoteTypes.MM));

    STATIC_QUOTES.push(new Quote('MM.USD.1D', QuoteTenor.T_1D, todayString, 0.0125, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.2D', QuoteTenor.T_2D, todayString, 0.0130, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.1W', QuoteTenor.T_1W, todayString, 0.0350, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.2W', QuoteTenor.T_2W, todayString, 0.0550, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.3W', QuoteTenor.T_3W, todayString, 0.0680, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.1M', QuoteTenor.T_1M, todayString, 0.0900, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.2M', QuoteTenor.T_2M, todayString, 0.1500, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.3M', QuoteTenor.T_3M, todayString, 0.1900, QuoteTypes.MM));
    STATIC_QUOTES.push(new Quote('MM.USD.6M', QuoteTenor.T_6M, todayString, 0.4500, QuoteTypes.MM));



    STATIC_QUOTES.push(new Quote('FX.EUR.USD.SPOT', QuoteTenor.SPOT, todayString, 1 / 0.81, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.JPY.SPOT', QuoteTenor.SPOT, todayString, 106.69, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.GBP.USD.SPOT', QuoteTenor.SPOT, todayString, 1 / 0.72, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.AUD.USD.SPOT', QuoteTenor.SPOT, todayString, 1 / 1.27, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.CAD.SPOT', QuoteTenor.SPOT, todayString, 1.29, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.CHF.SPOT', QuoteTenor.SPOT, todayString, 0.94, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.SEK.SPOT', QuoteTenor.SPOT, todayString, 8.2, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.SGD.SPOT', QuoteTenor.SPOT, todayString, 1.31, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.HKD.SPOT', QuoteTenor.SPOT, todayString, 7.84, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.NOK.SPOT', QuoteTenor.SPOT, todayString, 7.72, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.NZD.USD.SPOT', QuoteTenor.SPOT, todayString, 1 / 1.36, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.DKK.SPOT', QuoteTenor.SPOT, todayString, 6.01, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.RUB.SPOT', QuoteTenor.SPOT, todayString, 56.86, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.CNY.SPOT', QuoteTenor.SPOT, todayString, 6.32, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.MXN.SPOT', QuoteTenor.SPOT, todayString, 18.55, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.KRW.SPOT', QuoteTenor.SPOT, todayString, 1062.54, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.TRY.SPOT', QuoteTenor.SPOT, todayString, 3.86, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.ZAR.SPOT', QuoteTenor.SPOT, todayString, 11.78, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.INR.SPOT', QuoteTenor.SPOT, todayString, 64.73, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.BRL.SPOT', QuoteTenor.SPOT, todayString, 3.25, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.PLN.SPOT', QuoteTenor.SPOT, todayString, 3.4, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.TWD.SPOT', QuoteTenor.SPOT, todayString, 29.24, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.THB.SPOT', QuoteTenor.SPOT, todayString, 31.22, QuoteTypes.FX));
    STATIC_QUOTES.push(new Quote('FX.USD.MYR.SPOT', QuoteTenor.SPOT, todayString, 3.89, QuoteTypes.FX));

    return STATIC_QUOTES;
}
